import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["aria-controls", "aria-label", "disabled"]
const _hoisted_3 = ["aria-controls", "aria-label", "onClick"]
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = ["aria-controls", "aria-label", "disabled"]
const _hoisted_6 = ["aria-current"]

import { ref, computed, onMounted, watchEffect, nextTick } from "vue";

import { Video, Image } from "~/js/interfaces/media";

import { getIcon } from "~/js/composables/icons";
import { getClasses } from "~/js/composables/classes";

import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import VideoPrimary from "~/vue/atoms/videos/VideoPrimary.vue";
import ImageGallery from "~/vue/atoms/images/ImageGallery.vue";

interface A11Y {
	title: string;
	previous: string;
	next: string;
}

interface Props {
	animate?: boolean;
	videos: Array<Video> | any;
	images: Array<Image> | any;
	heading: string | null;
	a11y: A11Y;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderGallery',
  props: {
    animate: { type: Boolean, default: false },
    videos: { default: [] },
    images: { default: [] },
    heading: { default: null },
    a11y: {}
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	container: {
		animation: "transition-transform duration-700 ease-in-out",
		flex: "flex shrink-0",
		size: "w-screen",
	},
	controls: {
		flex: "flex items-center justify-end",
		space: "space-x-4",
	},
	dotsContainer: {
		display: "hidden sm:flex",
		space: "space-x-1",
	},
	dots: {
		animation: "transition-all",
		display: "inline-flex",
		background: "bg-viridian-500",
		layout: "rounded-full",
		size: "w-3 h-3",
	},
	header: {
		animate: props.animate ? "animate-fade-in" : "",
		flex: "flex items-center justify-between",
		margin: "mb-4",
		size: "w-full",
		space: "space-x-2",
	},
	prevnext: {
		background: "bg-viridian-500",
		color: "text-white",
		display: "flex items-center justify-center",
		layout: "rounded-full",
		size: "w-8 h-8",
	},
	prevnextDisabled: {
		background: "bg-concrete-300",
		color: "text-white",
		display: "flex items-center justify-center",
		layout: "rounded-full",
		size: "w-8 h-8",
	},
	scroller: {
		flex: "flex shrink-0",
		oveflow: "scrollbar-hide scroll-smooth snap-mandatory snap-x overflow-x-auto",
		size: "w-screen",
		space: "space-x-6 lg:space-x-8",
	},
	slide: {
		animate: props.animate ? "animate-slider-items" : "",
		display: "container max-w-screen-xl",
		flex: "sm:flex items-center shrink-0",
		size: "w-[75vw] max-w-[950px]",
		padding: "pl-0 pr-6 lg:pr-8",
		margin: "ml-0",
		layout: "rounded-4xl",
	},
	wrapper: {
		animate: props.animate ? "animate-slider" : "",
		flex: "flex justify-center relative",
		position: "relative",
	},
});
const ghost = ref<null | HTMLElement>(null);
const container = ref<null | HTMLElement>(null);
const scroller = ref<null | HTMLElement>(null);
const margin = ref(0);
// const translate = ref(0)
const activeSlide = ref(0);
const direction = ref("prev");
const reset = ref(false);

const updateSlide = (i: number, prevnext = true) => {
	if (i > activeSlide.value) {
		direction.value = "next";
	} else {
		direction.value = "prev";
	}

	activeSlide.value = i;
	setSpacings();

	if (prevnext) {
		prevNext();
	}

	reset.value = true;

	nextTick(() => {
		reset.value = false;
	});
};

const setSpacings = () => {
	margin.value = ghost.value?.getBoundingClientRect().left;
};

const prevNext = () => {
	const slide = ghost.value?.querySelectorAll(".slider-item")[1];

	if (slide) {
		// const padding = parseInt( (slide.currentStyle || window.getComputedStyle(slide)).paddingLeft ) * .5

		const position =
			direction.value == "prev"
				? scroller.value.scrollLeft - slide.offsetWidth
				: scroller.value.scrollLeft + slide.offsetWidth;

		scroller.value.scroll({
			left: slide.offsetWidth * activeSlide.value,
			top: 0,
			behavior: "smooth",
		});
		// translate.value = (slide?.getBoundingClientRect().width + padding) * (activeSlide.value - 1)
	}
};

const gallery = computed(() => {
	return [...props.videos, ...props.images];
});

const calculateActiveItem = () => {
	let setIndex = false;
	ghost.value.querySelectorAll(".slider-item").forEach((item) => {
		if (item.getBoundingClientRect().left >= 0 && !setIndex) {
			setIndex = true;
			const index = [...ghost.value.querySelectorAll(".slider-item")].indexOf(item);
			if (index !== activeSlide.value) {
				updateSlide(index, false);
			}
		}
	});
};

watchEffect(() => {
	if (scroller.value) {
		scroller.value.addEventListener("scroll", calculateActiveItem);
		calculateActiveItem();
		setSpacings();
	}
});

onMounted(() => {
	window.addEventListener("resize", () => {
		setSpacings();
	});

	setSpacings();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(_unref(getClasses)(classes.value, 'header'))
    }, [
      _createElementVNode("span", null, [
        (__props.heading)
          ? (_openBlock(), _createBlock(TextH3, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.heading), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (gallery.value.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_unref(getClasses)(classes.value, 'controls'))
          }, [
            _createElementVNode("button", {
              "aria-controls": __props.a11y.title,
              "aria-label": __props.a11y.previous,
              disabled: activeSlide.value === 0,
              class: _normalizeClass(
						activeSlide.value === 0 ? _unref(getClasses)(classes.value, 'prevnextDisabled') : _unref(getClasses)(classes.value, 'prevnext')
					),
              onClick: _cache[0] || (_cache[0] = () => updateSlide(activeSlide.value > 0 ? activeSlide.value - 1 : activeSlide.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(getIcon)('chevron-left'))
              }, null, 2)
            ], 10, _hoisted_2),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(getClasses)(classes.value, 'dotsContainer'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gallery.value, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id,
                  "aria-controls": __props.a11y.title,
                  "aria-label": `${i} / ${gallery.value.length}`,
                  class: _normalizeClass([_unref(getClasses)(classes.value, 'dots'), i === activeSlide.value ? 'opacity-100' : 'opacity-20']),
                  onClick: () => updateSlide(i)
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(i) + " / " + _toDisplayString(gallery.value.length), 1)
                ], 10, _hoisted_3))
              }), 128))
            ], 2),
            _createElementVNode("button", {
              "aria-controls": __props.a11y.title,
              "aria-label": __props.a11y.next,
              disabled: activeSlide.value === gallery.value.length - 1,
              class: _normalizeClass(
						activeSlide.value === gallery.value.length - 1
							? _unref(getClasses)(classes.value, 'prevnextDisabled')
							: _unref(getClasses)(classes.value, 'prevnext')
					),
              onClick: _cache[1] || (_cache[1] = () => updateSlide(activeSlide.value < gallery.value.length + 1 ? activeSlide.value + 1 : activeSlide.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(getIcon)('chevron-right'))
              }, null, 2)
            ], 10, _hoisted_5)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      ref_key: "ghost",
      ref: ghost,
      class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
    }, [
      _createElementVNode("div", {
        ref_key: "scroller",
        ref: scroller,
        class: _normalizeClass(_unref(getClasses)(classes.value, 'scroller'))
      }, [
        _createElementVNode("ul", {
          class: _normalizeClass(_unref(getClasses)(classes.value, 'container')),
          style: _normalizeStyle({
						paddingLeft: `${margin.value}px`,
					}),
          "aria-roledescription": "carousel"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gallery.value, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: _normalizeClass(["slider-item snap-end", _unref(getClasses)(classes.value, 'slide')]),
              "aria-current": i === activeSlide.value
            }, [
              (item?.hd)
                ? (_openBlock(), _createBlock(VideoPrimary, {
                    key: 0,
                    video: item,
                    reset: reset.value,
                    utilities: "rounded-3xl overflow-hidden w-full",
                    ratio: "aspect-4/3 lg:aspect-video"
                  }, null, 8, ["video", "reset"]))
                : (_openBlock(), _createBlock(ImageGallery, {
                    key: 1,
                    image: item.image,
                    utilities: "rounded-3xl overflow-hidden w-full",
                    ratio: "aspect-4/3 lg:aspect-video"
                  }, null, 8, ["image"]))
            ], 10, _hoisted_6))
          }), 128)),
          (gallery.value.length > 1)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "ml-0 shrink-0 grow-0 items-center sm:flex",
                style: _normalizeStyle({
							width: `${margin.value}px`,
						})
              }, null, 4))
            : _createCommentVNode("", true)
        ], 6)
      ], 2)
    ], 2)
  ]))
}
}

})